export default __webpack_public_path__ + "static/media/metabaselogo.39d634f2.png";